var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCompanyCallIcon = function SvgCompanyCallIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(-1167 -271)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 24,
    height: 24,
    rx: 3,
    transform: "translate(1167 271)",
    fill: "#f4f4f6",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "moving_ministry_FILL0_wght300_GRAD-25_opsz20",
    d: "M70.424-781.816v-12.26h9.01v12.26H75.927v-3.25h-2v3.25H70.424Zm.936-.936H73V-786h3.868v3.25H78.5V-793.14H71.36ZM73-787.637h1.117v-1.117H73Zm0-2.751h1.117V-791.5H73Zm2.751,2.751h1.117v-1.117H75.746Zm0-2.751h1.117V-791.5H75.746Zm8.2,4.921-.672-.661,1.357-1.349H81.369v-.936h3.263l-1.357-1.346.672-.664,2.476,2.48ZM73-782.752V-786h3.868v0H73Z",
    transform: "translate(1100.576 1070.946)",
    fill: "#3b3b3b"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompanyCallIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/companyCallIcon.de39cde1.svg";
export { ForwardRef as ReactComponent };